//
//
//
//
//
//
//
//
//

  import { dragMoveAction1 } from '@/common/utils/drag.js'
  export default{
    inject: ['parentRoot'],
    data() {
      return {
        gameUrl: null
      }
    },
    created() {
      this.gameUrl = this.$route.query.gameUrl
    },
    watch:{
      '$route': {
        handler(val,oldval){
          console.log(val)
          this.gameUrl = null
        },
        // 深度观察监听
        deep: true
      }
    },
    mounted() {
      this.$nextTick(() => {
        dragMoveAction1('backbtn01')
      })
    },
    methods: {
      handleJump() {
        this.gameUrl = null // 解决游戏禁止返回的问题
        this.$router.replace({ path: this.$route.query.backUrl })
      }
    }
  }



// WEBPACK FOOTER //
// ./src/pages/build800/views/game/details/index.vue